/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { ChildStateType } from '@/types/domain/child/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { api, service } from '@/share';

const initialState: ChildStateType = {
  childList: [],
  childId: '',
};

const updateIndex = (state: ChildStateType) => {
  const child = state.childList.find((v) => v.childId === state.childId);
  if (state.childList.length > 0
    && (child === undefined)) {
    state.childId = state.childList[0].childId;
    api.wagakoNurseryApi.setChildId(state.childList[0].childId);
  }
};

/**
 * 子どもSlice
 */
export const childSlice = createSlice({
  name: 'child',
  initialState,
  reducers: {
    /** 子どもリストをセット */
    setChildList: (state, action: PayloadAction<Array<ChildJson>>) => {
      state.childList = action.payload;
      updateIndex(state);
    },
    /** 子どもIDをセット */
    setChildId: (state, action: PayloadAction<string>) => {
      state.childId = action.payload;
      if (state.childList.find((v) => v.childId === state.childId)) {
        api.wagakoNurseryApi.setChildId(state.childId);
      }
    },
    /** 作成 */
    createChildStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.childList = service.child.createChildStore(
        state.childList,
        action.payload,
        undefined,
      );
      updateIndex(state);
    },
    /** 更新 */
    updateChildStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.childList = service.child.updateChildStore(
        state.childList,
        action.payload,
      );
      updateIndex(state);
    },
    /** 削除 */
    deleteChildStore: (state, action: PayloadAction<DeleteOutputType>) => {
      state.childList = service.child.deleteChildStore(
        state.childList,
        action.payload,
      );
      updateIndex(state);
    },
  },
});
